import React from "react";
import { deleteRecord, disableRecord, getAll } from "../../request/Request";
import { customColumn } from "../../service/dataTable";
import { productErrors } from "../../service/ErrorNotification/productErrors";
import { filterSelectData, selectAgent } from "../../service/comboBox";
import { ButtonAdd } from "../ButtonAdd";
import { ComboBox } from "../ComboBox/ComboBox";
import DataTableMaterial from "../DataTableMaterial/DataTableMaterial";
import { HeaderTable } from "../HeaderTable";
import ModalProduct from "../Modal/ModalProduct";
import ModalToDelete from "../Modal/ModalToDelete";
import ModalToEnable from "../Modal/ModalToEnable";
import Success from "../Notification/Success";
import Warning from "../Notification/Warning";
import { Search } from "../Search/Search";
import { AddOrEdit } from "./AddOrEdit";
import { array_equal, typeFilterSelect } from "../../service/defaultData";

export class Product extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            render: 'table',
            loading: true,
            dataTable: {
                data: [],
                perPage: 10,
                total: 0,
                currentPage: 1,
            },
            errorsRequest: {
                errorMessage: '',
                errorStatus: false
            },
            successRequest: {
                successMessage: '',
                successStatus: false
            },
            warningRequest: {
                successMessage: '',
                successStatus: false
            },
            dataToDelete: {
                show: false,
                data: {}
            },
            dataToEnable: {
                show: false,
                data: {}
            },
            modalProduct: {
                show: false,
                data: {}
            },
            productSelected: {}, 
            statusPetitionAgents: false,
            agents: [],
            enableAndDisabledAgents: [],
            agentSelected: {
                value: 0,
                label: ''
            },

            checkbox: true,
            unclassified: false,
            searchParam: '',
            defaultSearchParam: '',
            validationAgent: '',
            statusPetition: false,
        };
        this.getRowsPerPage = this.getRowsPerPage.bind(this);
        this.actionChange = this.actionChange.bind(this);
        this.getCurrentPage = this.getCurrentPage.bind(this);
        this.deleteProduct = this.deleteProduct.bind(this);
        this.disableProduct = this.disableProduct.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.comboBoxChange = this.comboBoxChange.bind(this);
        this.handleCheckbox = this.handleCheckbox.bind(this);
        this.searchProduct = this.searchProduct.bind(this);

    }

    componentDidMount() {
        this.getAllAgent();
        this.setState({ dataToDelete: { show: false, data: {} } });
        this.setState({ dataToEnable: { show: false, data: {} } });
    }

    componentDidUpdate(prevProps, prevState) {
        let { dataTable, render, agentSelected, unclassified, searchParam } = this.state;

        if ((prevState.dataTable.perPage !== dataTable.perPage || prevState.dataTable.currentPage !== dataTable.currentPage)
            ||
            (prevState.render !== render && render === 'table')
            || (agentSelected !== prevState.agentSelected) || (unclassified !== prevState.unclassified)) {
            this.setState({ defaultSearchParam: searchParam });
            this.setState({ validationAgent: "" });
            this.getAllProduct();
        }
    }

    actionChange(action) {
        if (action === 'add') this.setState({ productSelected: {} });
        this.setState({ render: action });
    }

    getCurrentPage(page) {
        let { dataTable, statusPetition } = this.state;
        if (!statusPetition) {
            this.setState({ dataTable: { ...dataTable, currentPage: page } });
        }
    }

    getRowsPerPage(perPage) {
        let { dataTable } = this.state;
        this.setState({ dataTable: { ...dataTable, perPage: perPage } });
    };

    async getAllProduct() {

        let { dataTable, agentSelected, unclassified, searchParam } = this.state;

        if (!dataTable.data.length) this.setState({ loading: true });

        if (agentSelected.value !== 0) {

            this.setState({ statusPetition: true });
            await getAll(`/product?page=${dataTable.currentPage - 1}&perPage=${dataTable.perPage}&idAgent=${agentSelected.value}&order=desc&unclassified=${unclassified}&search=${searchParam}`).then(request => {
                let { statusResponse, data } = request;
                if (statusResponse) {
                    this.setState({ dataTable: { ...dataTable, total: data.total, data: data.data } });
                } else {
                    this.setState({ dataTable: { ...dataTable, total: 0, data: [] } });
                }
            }).catch(error => {
                if (error.error === 404) {
                    this.setState({ dataTable: { ...dataTable, total: 0, data: [] } });
                } else {
                    this.setState({ errorsRequest: { errorMessage: 'Productos', errorStatus: true } });
                }
            });

        } else {
            this.setState({ loading: false });
        }
        this.setState({ statusPetition: false });
        this.setState({ loading: false });
    }

    async getAllAgent() {
        this.setState({ statusPetitionAgents: true });
        const agents = await selectAgent();
        if (agents.statusResponse) {
            let enableAndDisableAgentsTemp = filterSelectData(typeFilterSelect.get, agents.data);
            this.setState({ enableAndDisabledAgents: enableAndDisableAgentsTemp });
            this.setState({ agents: agents.data });
            this.setState({ loading: false });
            this.setState({ statusPetitionAgents: false });
        } else {
            this.setState({ errorsRequest: { errorMessage: 'Productos', errorStatus: true } });
            this.setState({ loading: false });
            this.setState({ statusPetitionAgents: false });
        }
    }

    comboBoxChange({ target }) {
        this.setState({ agentSelected: target });
        this.setState({ validationAgent: "" });
    }

    handleEdit(product) {
        this.actionChange('edit');
        this.setState({ productSelected: product });
    }

    handleDelete(product) {
        this.setState({ dataToDelete: { show: true, data: { ...product, name: product.product_name } } });
    }
    async deleteProduct(product) {

        await deleteRecord(`/product/${product.id_product}`).then(request => {

            let { dataTable } = this.state;
            let productTemp = dataTable.data.filter(x => x.id_product !== product.id_product);
            this.setState({ dataTable: { ...dataTable, total: productTemp.length, data: productTemp } });
            this.successNotifiaction('Producto eliminado', true);

        }).catch(error => {
            let respondeError = productErrors(error);
            if (respondeError === 'error') return this.setState({ errorsRequest: { errorMessage: 'Productos', errorStatus: true } });
            this.warningNotification(respondeError, true);
        });
        this.getAllProduct();
        this.setState({ dataToDelete: { show: false, data: {} } });
    }

    handleEnable(product) {
        this.setState({ dataToEnable: { show: true, data: { ...product, name: product.product_name } } });
    }
    async disableProduct(product) {

        await disableRecord(`/product/${product.id_product}`).then(request => {
            let { statusResponse } = request;
            if (statusResponse) {

                let { dataTable } = this.state;
                dataTable.data.map(function (prod) {
                    if (prod.id_product === product.id_product) prod.enable = false;
                });
                this.successNotifiaction('Producto desactivado', true);
                this.setState({ ...dataTable, data: dataTable.data });

            }
        }).catch(error => {
            let respondeError = productErrors(error);
            if (respondeError === 'error') return this.setState({ errorsRequest: { errorMessage: 'Productos', errorStatus: true } });
            this.warningNotification(respondeError, true);
        });
        this.setState({ dataToEnable: { show: false, data: {} } });
    }

    successNotifiaction(msg, status) {
        this.setState({ ...this.state, successRequest: { successMessage: msg, successStatus: status } });
        setTimeout(() => {
            this.setState({ ...this.state, successRequest: { successMessage: '', successStatus: false } });
        }, 2500);
    }
    warningNotification(msg, status) {
        this.setState({ ...this.state, warningRequest: { successMessage: msg, successStatus: status } });
        setTimeout(() => {
            this.setState({ ...this.state, warningRequest: { successMessage: '', successStatus: false } });
        }, 2500);
    }

    createdOrEditProduct = (action) => {
        if (action === 'created') {
            this.successNotifiaction('Producto agregado', true);
        } else {
            this.successNotifiaction('Producto actualizado', true);
        }
    }

    handleSearch(value) {
        this.setState({ searchParam: value });
    }

    searchProduct() {
        let { searchParam, agentSelected } = this.state;
        if (searchParam === '' || agentSelected.label === '') {
            this.setState({ validationAgent: "*El agente es requerido" });
        }
        if (agentSelected.label !== '') {
            this.setState({ validationAgent: "" });
        }
        this.getAllProduct();
    }

    handleCheckbox(e) {
        let { checkbox } = this.state;
        this.setState({ checkbox: !checkbox });

        if (checkbox) {
            this.setState({ unclassified: true });
        }
        else {
            this.setState({ unclassified: false });
        }

    }

    materialDataTable() {
        let { dataTable, loading, errorsRequest } = this.state;
        let columns = [
            {
                ...customColumn('Código', row => row.product_code),
                cell: row => <p className="capitalize-text">{row.product_code ? row.product_code : '-'}</p>,
            },
            {
                ...customColumn('Nombre', row => row.product_name),
                cell: row => <p className="capitalize-text">{row.product_name ? row.product_name : '-'}</p>,
            },
            {
                ...customColumn('Categoría', row => row.vinci_category_name),
                cell: row => <p className="capitalize-text">{row.vinci_category_name ? row.vinci_category_name : '-'}</p>,
            },
            {
                ...customColumn('Grupo', row => row.vinci_group_name),
                cell: row => <p className="capitalize-text">{row.vinci_group_name ? row.vinci_group_name : '-'}</p>,
            },
            {
                ...customColumn('Sub-Grupo', row => row.vinci_subgroup_name),
                cell: row => <p className="capitalize-text">{row.vinci_subgroup_name ? row.vinci_subgroup_name : '-'}</p>,
            },
            {
                ...customColumn('Estado', row => row.enable),
                cell: (row) =>
                    <span onClick={() => { row.enable && this.handleEnable(row) }} className={row.enable ? ` active-status` : 'inactive-status'}> {
                        row.enable ? 'Activo' : 'Inactivo'
                    } </span>
                ,
            },
            {
                ...customColumn('Acciones'),
                cell: (row) => (
                    <div className="actions-buttons">
                        <button className="botton-delete">
                            <svg onClick={() => { this.handleDelete(row) }} className="svg-icon" viewBox="0 0 20 20">
                                <path d="M17.114,3.923h-4.589V2.427c0-0.252-0.207-0.459-0.46-0.459H7.935c-0.252,0-0.459,0.207-0.459,0.459v1.496h-4.59c-0.252,0-0.459,0.205-0.459,0.459c0,0.252,0.207,0.459,0.459,0.459h1.51v12.732c0,0.252,0.207,0.459,0.459,0.459h10.29c0.254,0,0.459-0.207,0.459-0.459V4.841h1.511c0.252,0,0.459-0.207,0.459-0.459C17.573,4.127,17.366,3.923,17.114,3.923M8.394,2.886h3.214v0.918H8.394V2.886z M14.686,17.114H5.314V4.841h9.372V17.114z M12.525,7.306v7.344c0,0.252-0.207,0.459-0.46,0.459s-0.458-0.207-0.458-0.459V7.306c0-0.254,0.205-0.459,0.458-0.459S12.525,7.051,12.525,7.306M8.394,7.306v7.344c0,0.252-0.207,0.459-0.459,0.459s-0.459-0.207-0.459-0.459V7.306c0-0.254,0.207-0.459,0.459-0.459S8.394,7.051,8.394,7.306"></path>
                            </svg>
                        </button>
                        <button className="botton-edit">
                            <svg onClick={() => { this.handleEdit(row) }} className="svg-icon" viewBox="0 0 20 20">
                                <path d="M19.404,6.65l-5.998-5.996c-0.292-0.292-0.765-0.292-1.056,0l-2.22,2.22l-8.311,8.313l-0.003,0.001v0.003l-0.161,0.161c-0.114,0.112-0.187,0.258-0.21,0.417l-1.059,7.051c-0.035,0.233,0.044,0.47,0.21,0.639c0.143,0.14,0.333,0.219,0.528,0.219c0.038,0,0.073-0.003,0.111-0.009l7.054-1.055c0.158-0.025,0.306-0.098,0.417-0.211l8.478-8.476l2.22-2.22C19.695,7.414,19.695,6.941,19.404,6.65z M8.341,16.656l-0.989-0.99l7.258-7.258l0.989,0.99L8.341,16.656z M2.332,15.919l0.411-2.748l4.143,4.143l-2.748,0.41L2.332,15.919z M13.554,7.351L6.296,14.61l-0.849-0.848l7.259-7.258l0.423,0.424L13.554,7.351zM10.658,4.457l0.992,0.99l-7.259,7.258L3.4,11.715L10.658,4.457z M16.656,8.342l-1.517-1.517V6.823h-0.003l-0.951-0.951l-2.471-2.471l1.164-1.164l4.942,4.94L16.656,8.342z"></path>
                            </svg>
                        </button>
                    </div>
                ),
            },

        ];

        return <DataTableMaterial
            dataTableData={dataTable}
            loading={loading}
            errors={errorsRequest}
            columns={columns}
            getRowsPerPage={this.getRowsPerPage}
            getCurrentPage={this.getCurrentPage}
        />;
    }

    render() {

        let { render, dataToDelete, productSelected, dataToEnable, unclassified, agents, enableAndDisabledAgents, defaultSearchParam,
            successRequest, errorsRequest, modalProduct, agentSelected, warningRequest, validationAgent, statusPetitionAgents } = this.state;

        return (
            <div className="col-lg-12 mt-5">
                {
                    render === 'add' || render === 'edit' ?
                        <AddOrEdit agents={agents} render={render} product={productSelected} actionChange={this.actionChange} createdOrEditProduct={this.createdOrEditProduct} /> :
                        <div className="card-table">
                            <HeaderTable title={'Productos'} />
                            {modalProduct?.data && <ModalProduct dataProduct={modalProduct} />}
                            <ModalToEnable record={dataToEnable} disableRecord={this.disableProduct} />
                            <ModalToDelete record={dataToDelete} deleteRecord={this.deleteProduct} />
                            {warningRequest.successStatus && <Warning text={warningRequest.successMessage} />}
                            {successRequest.successStatus && <Success text={successRequest.successMessage} />}
                            {!errorsRequest.errorStatus &&
                                <div>

                                    <div className="row mt-3 container-search-button">
                                        <div className="col-md-4 pl-0">
                                            <ComboBox
                                                name={"id_agent"}
                                                text={"Seleccionar Agente"}
                                                isLoading={statusPetitionAgents}
                                                options={enableAndDisabledAgents}
                                                onChange={this.comboBoxChange}
                                                defaultValueSelect={agentSelected}
                                            />
                                            {validationAgent && (<p className="help is-danger">{validationAgent}</p>)}
                                        </div>
                                    </div>

                                    <div className="flex">
                                        <div className="row mt-3">
                                            <div className="col-md-8">
                                                <div className="row">
                                                    <div className="col-md-6" id="container-input-search" >
                                                        <Search defaultValue={defaultSearchParam} handleSearch={this.handleSearch} />
                                                    </div>

                                                    <div className="col-md-6 ">
                                                        <div className=" container-bottons">
                                                            <button onClick={this.searchProduct} className="btn-coriport btn-add">Buscar</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4" >
                                                <div className="float-right">
                                                    <ButtonAdd actionChange={this.actionChange} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row   mb-4 container-search-button">
                                        <div className=" form-check" >
                                            <input value={unclassified} checked={unclassified} onChange={this.handleCheckbox} type="checkbox" className="form-check-input" style={{ marginTop: '5px' }}></input>
                                            <label className="form-check-label" id="label-checkBox" >Filtrar sin Clasificación </label>
                                        </div>
                                    </div>

                                </div>

                            }

                            <div className="mb-5 mt-4">
                                {this.materialDataTable()}
                            </div>
                        </div>
                }
            </div>
        )
    }

}